import script from "./CreateEvent.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateEvent.vue?vue&type=script&setup=true&lang=ts"

import "./CreateEvent.vue?vue&type=style&index=0&id=654b8006&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-654b8006"]])

export default __exports__